import {
    useEffect,
    useState,
    FunctionComponent,
    Fragment,
    useMemo,
} from 'react';
import { useNavigate } from 'react-router-dom';

// Third-party modules
import { Auth } from 'aws-amplify';
import {
    IconButton,
    Tooltip,
    Badge,
    AppBar,
    Toolbar,
    Menu,
    MenuItem,
} from '@mui/material';

// Local modules
import { NOTIFICATION_MOCKS } from './constants';
import NotificationDrawer from './NotificationDrawer';
import { SHAKE_ANIMATION_STRING } from 'src/styles';
import { useGetPopulateUser } from 'src/modules/hooks/apis/sql/users';
import { LoadingBackdrop } from '@components';

//icons
import { UserCircle, Bell, ChatsCircle } from '@phosphor-icons/react';

//hooks
import { useQueryGetPopulateThreads } from '../hooks/apis/sql/threads';

//redux
import { useSelector } from 'react-redux';
import { selectEmailsCount } from '../../modules/redux/emailsSlice';

// Create a style element to add the shake animation to the DOM
const styleElement = document.createElement('style');
styleElement.innerHTML = SHAKE_ANIMATION_STRING;
document.head.appendChild(styleElement);

const TopAppBar: FunctionComponent = () => {
    // API hooks
    const {
        data: userAuth,
        error: userAuthError,
        isError: isUserAuthError,
        isLoading: isUserAuthLoading,
    } = useGetPopulateUser();

    // Compute the unread count by filtering emails with status 'New'

    const emails = useSelector(selectEmailsCount);
    const unreadCount = emails.filter(
        (email: any) => email.status.toLowerCase() === 'new'
    ).length;

    // Component state
    const [notifications, setNotifications] = useState(NOTIFICATION_MOCKS);
    const [isNotificationOpen, setNotificationOpen] = useState(false);
    const [profileMenuAnchor, setProfileMenuAnchor] =
        useState<null | HTMLElement>(null);

    // Navigate to Threads
    const navigate = useNavigate();
    const handleNavigate = () => {
        navigate('/threads');
    };

    // Side effects
    /* Handle the case that a user cannot be authenticated */
    useEffect(() => {
        // if (isUserAuthError) {
        // TODO: Replace this with a proper error handling mechanism
        // console.log('Authentication Error:', userAuthError);
        // }
    }, [userAuthError, isUserAuthError]);

    if (isUserAuthLoading) {
        return <LoadingBackdrop />;
    }

    return (
        <Fragment>
            <NotificationDrawer
                open={isNotificationOpen}
                onClose={() => setNotificationOpen(false)}
                notifications={notifications}
                onMarkAsRead={(notificationId: number) => {
                    const updatedNotifications = notifications.map(
                        (notification: any) => {
                            if (notification.id === notificationId) {
                                return {
                                    ...notification,
                                    status: 'read',
                                };
                            }
                            return notification;
                        }
                    );
                    setNotifications(updatedNotifications);
                }}
            />
            <AppBar sx={{ backgroundColor: '#FFFFFF' }}>
                <Toolbar
                    sx={{
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'flex-end',
                    }}
                >
                    {/* <Typography variant="h6" color="black" noWrap>
						Welcome, {userAuth?.user.info.first_name}&nbsp;
						{userAuth?.user.info.last_name}
					</Typography> */}
                    <Tooltip title="Threads">
                        <IconButton onClick={handleNavigate}>
                            <Badge badgeContent={unreadCount} color="error">
                                <ChatsCircle
                                    size={24}
                                    color="#1D4A74"
                                    weight="fill"
                                />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Profile">
                        <IconButton
                            onClick={event =>
                                setProfileMenuAnchor(event.currentTarget)
                            }
                        >
                            <UserCircle
                                size={24}
                                color="#1D4A74"
                                weight="fill"
                            />
                        </IconButton>
                    </Tooltip>
                    <Menu
                        id="profile-menu"
                        anchorEl={profileMenuAnchor}
                        open={Boolean(profileMenuAnchor)}
                        onClose={() => setProfileMenuAnchor(null)}
                    >
                        <MenuItem onClick={() => setProfileMenuAnchor(null)}>
                            Profile
                        </MenuItem>
                        <MenuItem
                            onClick={async () => {
                                try {
                                    await Auth.signOut();
                                    console.log('User signed out successfully');
                                } catch (error) {
                                    console.error('Error signing out:', error);
                                } finally {
                                    setProfileMenuAnchor(null);
                                }
                            }}
                        >
                            Sign Out
                        </MenuItem>
                    </Menu>

                    {/* <Tooltip title="Notifications">
                        <IconButton
                            style={{
                                animation: hasUnreadNotifications
                                    ? 'bell-ring 0.5s ease-in-out infinite'
                                    : 'none',
                            }}
                            onClick={() => setNotificationOpen(true)}
                        >
                            {hasUnreadNotifications ? (
                                <Badge
                                    badgeContent={
                                        notifications.filter(
                                            (notification: any) =>
                                                notification.status === 'unread'
                                        ).length
                                    }
                                    color="error"
                                >
                                    <NotificationsIcon
                                        sx={{ color: '#1D4A74' }}
                                    />
                                </Badge>
                            ) : (
                                <NotificationsIcon sx={{ color: '#1D4A74' }} />
                            )}
                        </IconButton>
                    </Tooltip> */}
                </Toolbar>
            </AppBar>
        </Fragment>
    );
};

export default TopAppBar;
